var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Frame',{staticClass:"bind",attrs:{"name":_vm.title}},[(_vm.type==1)?_c('BindResult'):_c('BindForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }